export default __webpack_public_path__ + "static/media/addButton.9974ca32.svg";